import React from 'react';
import IEmptyState from "EmptyState";
import classNames from 'classnames';

interface IServiceSpecialtyItemProps {
    title: string;
    photoUrl: string;
    reversed: boolean;
}

export default class ServiceSpecialtyItem extends React.Component<IServiceSpecialtyItemProps, IEmptyState> {
    constructor(props: IServiceSpecialtyItemProps) {
        super(props);
    }

    public render() {
        return (
            <div className={classNames("specialty-item", {"reversed": this.props.reversed})}>
                <div className="background-container">
                    <div className="background" style={{backgroundImage: 'url(' + this.props.photoUrl + ')'}}></div>
                </div>
                <div className="content">
                    <h3 className="title">
                        {this.props.title}
                    </h3>
                </div>
            </div>
        );
    }
}